import { render, staticRenderFns } from "./UserPermissionsCard.vue?vue&type=template&id=0c28b090&scoped=true&"
import script from "./UserPermissionsCard.vue?vue&type=script&lang=js&"
export * from "./UserPermissionsCard.vue?vue&type=script&lang=js&"
import style0 from "./UserPermissionsCard.vue?vue&type=style&index=0&id=0c28b090&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c28b090",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VBtn,VCheckbox,VChip})
